import { FieldConfigs } from "../shared/components/FormType";

export const Search = {
    searchText: "Tìm kiếm theo từ khoá Mã nhà cung cấp, Tên nhà cung cấp",
};

export const ProviderTableColumns = [
    { text: "Mã nhà cung cấp", icon: <></> },
    { text: "Tên nhà cung cấp", icon: <></> },
    { text: "Số điện thoại", icon: <></> },
    { text: "Email", icon: <></> },
    { text: "Người liên hệ", icon: <></> },
    // { text: "Tỉnh/Thành phố", icon: <></> },
    // { text: "Tổng đơn hàng liên quan", icon: <></> },
    // { text: "Đơn hàng hiện tại", icon: <></> },
];

export const ProviderLinkMaterialTableColumns = [
    { text: "Nhà cung cấp", icon: <></> },
    { text: "Người liên hệ", icon: <></> },
    { text: "Giá cung cấp", icon: <></> },
    { text: "Ghi chú", icon: <></> },
    { text: "", icon: <></> },
];

export const MaterialTableColumns = [
    { text: "Tên vật tư", icon: <></> },
    { text: "Đơn vị", icon: <></> },
    { text: "Giá cung cấp", icon: <></> },
    { text: "Ghi chú", icon: <></> },
    { text: "", icon: <></> },
];

export const CreateProviderTitleBar = {
    title: "Tạo mới nhà cung cấp",
    cancelButton: "Huỷ bỏ",
    addButton: "Lưu nhà cung cấp",
};

export const DetailProviderTitleBar = {
    deleteButton: "Xoá nhà cung cấp",
    saveButton: "Lưu nhà cung cấp",
    createOrderButton: "Tạo đơn hàng sản phẩm",
};

export const DeleteProviderModal = {
    title: "Xoá nhà cung cấp",
    context:
        "Bạn có muốn xoá người liên hệ khỏi danh sách không? \n" +
        "Hành động này sẽ không được hoàn tác.",
};

export const WarningProviderModal = {
    title: "Huỷ bỏ",
    context:
        "Thông tin bạn đã cung cấp sẽ không được lưu, bạn có chắc chắn " +
        "muốn huỷ bỏ không? Hành động này sẽ không được hoàn tất.",
};

export const basicFields: FieldConfigs[] = [
    { label: "Đơn vị nội bộ", type: "toggle", key: "is_internal", hideToggleText: true, required: true },
    { label: "Cũng là nhà gia công", type: "toggle", key: "is_outsource_provider", hideToggleText: true, required: true },
    {
        label: "Mã nhà cung cấp",
        type: "text",
        key: "provider_code",
        required: true,
    },
    {
        label: "Tên nhà cung cấp",
        type: "text",
        key: "name",
        required: true,
    },
    {
        label: "Số điện thoại",
        type: "text",
        key: "phone",
        required: true,
    },
    { label: "Mã số thuế", type: "text", key: "tax_id", required: true },
    {
        label: "Số fax",
        type: "text",
        key: "fax",
        required: false,
    },
    {
        label: "Email",
        type: "text",
        key: "email",
        required: true,
        validation: "email",
    },
    { label: "Địa chỉ", type: "text", key: "address", required: true },
    { label: "Số ngày nợ", type: "text", key: "payable_days", validation: "number", isInteger: true, required: true },
    { label: "Tên tài khoản", type: "text", key: "bank_account_name", required: true },
    { label: "Tên ngân hàng", type: "text", key: "bank_name", required: true },
    { label: "Số tài khoản", type: "text", key: "bank_account_number", required: true },
    // { label: "Quốc gia", type: "text", key: "country", required: true },
    // { label: "Tỉnh/Thành phố", type: "text", key: "city", required: true },
    // { label: "Quận/Huyện", type: "text", key: "district", required: true },
    // { label: "Phường/Xã", type: "text", key: "ward", required: true },
    // { label: "Địa chỉ", type: "text", key: "home_address", required: true },
];
